import { HTTP_PROTOCOL_PREFIX } from '@/constants/regex';

// Slashs finaux retirés sans regex : /\/+$/ a un temps de backtracking super-linéaire (règle Sonar S8786).
const trimTrailingSlashes = (value: string) => {
  let end = value.length;
  while (end > 0 && value[end - 1] === '/') end -= 1;
  return value.slice(0, end);
};

const normalizeUrl = (url: string | null | undefined): string =>
  trimTrailingSlashes((url ?? '').trim().toLowerCase().replace(HTTP_PROTOCOL_PREFIX, ''));

export default normalizeUrl;
